export default {
  NONE: 1,
  SHORTAGE: 2,
  OVERAGE: 3,
  PENDDING: 4,
  CHECKED: 5,
  APPLIED: 10,
  options: {
    1: '未確認',
    2: '不足',
    3: '超過',
    4: '保留',
    5: '確認済',
    10: '適用済',
  },
}



// WEBPACK FOOTER //
// ./src/consts/ShiftPlanStatus.js